import { render, staticRenderFns } from "./add-designer.vue?vue&type=template&id=2651b2b6&scoped=true"
import script from "./add-designer.vue?vue&type=script&lang=js"
export * from "./add-designer.vue?vue&type=script&lang=js"
import style0 from "./add-designer.vue?vue&type=style&index=0&id=2651b2b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2651b2b6",
  null
  
)

export default component.exports